import { useFormik } from 'formik'
import { useState } from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import Icon from '../../Icon/Icon'
import Radio from '../../Inputs/Radio/Radio'
import RadioGroup from '../../Inputs/RadioGroup/RadioGroup'
import Typography from '../../Typography/Typography'

import './FormAgreements.scss'

const FormAgreements = ({ isPersonalGDPR, isNonPersonalGDPR, loading, handleSubmit }) => {
    const [isOpen, setIsOpen] = useState(false)
    const intl = useIntl()

    const formik = useFormik({
        initialValues: {
            personal: isPersonalGDPR,
            nonPersonal: isNonPersonalGDPR,
        },
        validationSchema: Yup.object({
            personal: Yup.boolean().oneOf(
                [true, false],
                intl.formatMessage({ id: 'forms.agreements.checkBoxNotChecked' })
            ),
            nonPersonal: Yup.boolean().oneOf(
                [true, false],
                intl.formatMessage({ id: 'forms.agreements.checkBoxNotChecked' })
            ),
        }),
        onSubmit: (values) => {
            handleSubmit(values)
            setIsOpen(false)
            return null
        },
    })

    return (
        <Container fluid className="form-agreements d-flex flex-column w-100">
            <div
                role={'button'}
                onClick={() => setIsOpen((prevState) => !prevState)}
                className="d-flex justify-content-between align-items-center"
            >
                <Typography variant={'subtitle'}>
                    {intl.formatMessage({
                        id: 'forms.agreements.title',
                    })}
                </Typography>
                <Icon name={isOpen ? 'chevron–up' : 'chevron–down'} />
            </div>
            <form
                onSubmit={formik.handleSubmit}
                className={`form-agreements--form ${isOpen ? 'd-flex' : 'd-none'} flex-column`}
            >
                <Typography variant={'p'}>
                    {intl.formatMessage({
                        id: 'forms.agreements.description',
                    })}
                </Typography>

                <RadioGroup
                    label={intl.formatMessage({
                        id: 'forms.agreements.nonPersonal',
                    })}
                    id={'personal'}
                    error={formik?.errors?.personal}
                    touched={formik?.touched?.personal}
                    {...formik.getFieldProps('personal')}
                >
                    <Radio
                        label={intl.formatMessage({
                            id: 'buttons.yes',
                        })}
                        name={'personal'}
                        value={true}
                        error={formik?.errors?.personal}
                        touched={formik?.touched?.personal}
                        disabled={loading}
                        defaultChecked={formik?.values?.personal === true}
                    />
                    <Radio
                        label={intl.formatMessage({
                            id: 'buttons.no',
                        })}
                        name={'personal'}
                        value={false}
                        error={formik?.errors?.personal}
                        touched={formik?.touched?.personal}
                        disabled={loading}
                        defaultChecked={formik?.values?.personal === false}
                    />
                </RadioGroup>

                <RadioGroup
                    label={intl.formatMessage({
                        id: 'forms.agreements.personal',
                    })}
                    id={'nonPersonal'}
                    error={formik?.errors?.nonPersonal}
                    touched={formik?.touched?.nonPersonal}
                    {...formik.getFieldProps('nonPersonal')}
                >
                    <Radio
                        label={intl.formatMessage({
                            id: 'buttons.yes',
                        })}
                        name={'nonPersonal'}
                        value={true}
                        error={formik?.errors?.nonPersonal}
                        touched={formik?.touched?.nonPersonal}
                        disabled={loading}
                        defaultChecked={formik?.values?.nonPersonal === true}
                    />
                    <Radio
                        label={intl.formatMessage({
                            id: 'buttons.no',
                        })}
                        name={'nonPersonal'}
                        value={false}
                        error={formik?.errors?.nonPersonal}
                        touched={formik?.touched?.nonPersonal}
                        disabled={loading}
                        defaultChecked={formik?.values?.nonPersonal === false}
                    />
                </RadioGroup>

                <Container fluid>
                    <ButtonCinestar variant={'primary-v1'} type={'submit'} disabled={loading}>
                        {intl.formatMessage({
                            id: 'buttons.buttonSave',
                        })}
                    </ButtonCinestar>
                </Container>
            </form>
        </Container>
    )
}

export default FormAgreements
